import { useEffect, useState } from "react"
import { LuMinus } from "react-icons/lu";
import { LuPlus } from "react-icons/lu";

export const ContadorProducto = ({idProducto, contador=1, aumentarCallback=()=>{}, disminuirCallback=()=>{},resetCallback=()=>{}}) => {
    const [pop, setPop] = useState(false);

    useEffect(()=>{
        setPop(true)
        setTimeout(()=>setPop(false),150)
    },[contador])    

    useEffect(() => {
        resetCallback()        
      }, [idProducto]);
      
    return (
        <div className="quantity-selector">
            <button className="qty-btn" id="btnMinus" aria-label="Disminuir cantidad" disabled={contador===1} onClick={disminuirCallback}><LuMinus/></button>
            <div className={`quantity-number ${pop?"pop":""}`} id="quantityDisplay">{contador}</div>
            <button className="qty-btn" id="btnPlus" aria-label="Aumentar cantidad" onClick={aumentarCallback}><LuPlus/></button>
        </div>        
    )
}
